const server = {
  // baseUrl: 'https://credexon-api.sandboxdevelopment.in',
  proBaseUrl: "https://preapi.credexon.com",
  devBaseUrl: "http://localhost:8881",
  // prod: '',
};
export function baseUrlPostGres() {
  return (process.env.REACT_APP_BASE_URL=="sandbox")? server.devBaseUrl:server.proBaseUrl;
}
